export default __webpack_public_path__ + "static/media/erroricon.029045d0.svg";